import { render, staticRenderFns } from "./ButtonAction.vue?vue&type=template&id=7b48c1d2&scoped=true&"
import script from "./ButtonAction.vue?vue&type=script&lang=js&"
export * from "./ButtonAction.vue?vue&type=script&lang=js&"
import style0 from "./ButtonAction.vue?vue&type=style&index=0&id=7b48c1d2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b48c1d2",
  null
  
)

export default component.exports